import { MessageFileCategories, MessageType } from '~/constants';
import { getEmbeddedWebLinks } from '~/helpers';
import { emitMessage } from '~/api/ws/queries';
import { getShortLinks, processLinks } from '~/api/shortLinks';
import { getConversations } from '~/selectors/conversations';

const processMessageWithLinks = async ({
  content,
  conversationID,
  short_links_enabled,
  apiKey,
  conversations,
}) => {
  const {
    agent_id,
    payload: { text, type },
  } = content;

  const { phone: customerNumber } = conversations.find(
    ({ id }) => id === conversationID
  );

  const messageLinks = getEmbeddedWebLinks(text);

  if (messageLinks.length > 0) {
    await processLinks({ links: messageLinks, apiKey }).catch((e) => e);

    if (short_links_enabled) {
      const { links } = await getShortLinks({
        customerNumber,
        links: messageLinks,
      });

      const result = links.reduce(
        (resultString, nextLink) =>
          resultString.replace(nextLink.base, nextLink.short),
        text
      );

      return emitMessage(
        { agent_id, payload: { text: result, type } },
        conversationID
      );
    }
  }

  return emitMessage({ agent_id, payload: { text, type } }, conversationID);
};

const createMessage =
  ({ conversationID, message, agentID }) =>
  async (dispatch, getState) => {
    const state = getState();

    const {
      user: {
        config: { short_links_enabled, mw_api_key },
      },
    } = state;

    const conversations = getConversations(state);

    const {
      payload: { type },
    } = message;

    if (type === MessageType.TEXT) {
      await processMessageWithLinks({
        content: { agent_id: agentID, ...message },
        conversationID,
        short_links_enabled,
        apiKey: mw_api_key,
        conversations,
      });
    } else {
      emitMessage({ agent_id: agentID, ...message }, conversationID);
    }
  };

const createImageMessages =
  ({ imageMap, customer_id, agentID }) =>
  (dispatch) => {
    const images = Array.from(imageMap.values());

    const imageMessages = images.map(
      ({ mime_type, full_size, url, thumbnail, preview }) => ({
        type: MessageType.FILE,
        category: MessageFileCategories.IMAGE,
        src: {
          mime: mime_type,
          size: Number(full_size),
          uri: url,
        },
        thumbnail: {
          mime: mime_type,
          size: Number(full_size),
          uri: thumbnail,
        },
        preview: {
          mime: mime_type,
          size: Number(full_size),
          uri: preview,
        },
      })
    );

    const message = {
      payload: {
        type: MessageType.IMAGE_LIST,
        images: imageMessages,
      },
    };

    dispatch(
      createMessage({
        agentID,
        message,
        conversationID: customer_id,
      })
    );
  };

export { createMessage, createImageMessages };
